import { FC } from "react";
import styles from "../Chat.module.scss";
import { createPortal } from "react-dom";
// Модальное окно вынесено в отдельный компонент

export type ModalType = "block" | "delete" | "unblock" | null;

export interface ModalProps {
  open: boolean;
  type: ModalType;
  onCancel: () => void;
  onConfirm: () => void;
}

export const ConfirmModal: FC<ModalProps> = ({
  open,
  type,
  onCancel,
  onConfirm,
}) => {
  if (!open) return null;

  // Определяем текст и стили в зависимости от типа действия
  let title = "";
  let text = "";
  let confirmText = "";
  let confirmButtonClass = "";

  if (type === "block") {
    title = "Block User";
    text =
      "Are you sure you want to block this user? You will no longer receive messages from them.";
    confirmText = "Block";
    confirmButtonClass = styles.blockButton;
  } else if (type === "unblock") {
    title = "Unblock User";
    text =
      "Are you sure you want to unblock this user? You will be able to exchange messages again.";
    confirmText = "Unblock";
    confirmButtonClass = styles.unblockButtonModal;
  } else if (type === "delete") {
    title = "Delete Conversation";
    text =
      "Are you sure you want to delete this conversation? All message history will be permanently removed.";
    confirmText = "Delete";
    confirmButtonClass = styles.deleteButton;
  }

  return createPortal(
    <div className={styles.modalOverlay}>
      <div className={styles.modalContent}>
        <h3 className={styles.modalTitle}>{title}</h3>
        <p className={styles.modalText}>{text}</p>
        <div className={styles.modalActions}>
          <button className={styles.modalCancelButton} onClick={onCancel}>
            Cancel
          </button>
          <button
            className={`${styles.modalConfirmButton} ${confirmButtonClass}`}
            onClick={onConfirm}
          >
            {confirmText}
          </button>
        </div>
      </div>
    </div>,
    document.body,
  );
};
